import { Injectable } from '@angular/core';
// Angular imports
import { Subject } from '../common/angular.index';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class SideBarService {

  toggler: Subject<boolean>;
  currentPath: Subject<string>;
  constructor(
    private storageService: StorageService

  ) { 
    this.toggler = new Subject();
    this.currentPath = new Subject();

    // this.toggler.subscribe(next => {
    //   console.log(`damm crack`, next);
    // });
  }

  
}
